import _clone from 'lodash/clone';
import { createSelector } from 'reselect';

export const getTestSetEntries = ({ testSetEntries }) =>
  testSetEntries.list.data.items;

export const getTestSetEntriesList = createSelector(
  getTestSetEntries,
  entries =>
    entries.map(entry => ({
      ...entry,
      initialValue: _clone(entry.value),
    })),
);

export const getTestSetEntriesIds = createSelector(
  getTestSetEntries,
  entries => entries.map(({ id }) => id),
);

export const getTestSetEntriesListCount = ({ testSetEntries }) =>
  testSetEntries.list.data.count;

export const getIsLoadingList = ({ testSetEntries }) =>
  testSetEntries.list.isLoading;

export const getPaginationOptions = ({ testSetEntries }) =>
  testSetEntries.list.paginationOptions;

export const getIsAdding = ({ testSetEntries }) => testSetEntries.add.isLoading;

export const getIsUpdating = ({ testSetEntries }) =>
  testSetEntries.update.isLoading;

export const getIsDeleting = ({ testSetEntries }) =>
  testSetEntries.delete.isLoading;
